module.exports = __webpack_public_path__ + "static/tata-7b027690fa0eec1498eef530674f002f.png";